/* Source: /tmp/jac-app-precompile-2740-qj0nt_zq/app/pages/[...notFound].jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { Link } from "@jac/runtime";
function Page() {
  return __jacJsx("section", {"className": "not-found"}, [__jacJsx("p", {"className": "eyebrow"}, ["404"]), __jacJsx("h1", {"className": "display"}, ["Not found."]), __jacJsx("p", {}, ["The page you're looking for doesn't exist. Try the", " ", __jacJsx(Link, {"to": "/issues"}, ["archive"]), "."])]);
}
const page = Page;
/*jac:refresh-boundary*/;
export {page};
//# sourceMappingURL=[...notFound].js.map
